import React, { createContext, ReactNode, useContext, useState } from "react";
import Cookies from "js-cookie";

interface TenantContextValue {
  tenantId?: number;
}

const TenantContext = createContext<TenantContextValue | undefined>(undefined);

export const useTenant = (): TenantContextValue => {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error("useTenant must be used within a TenantProvider");
  return ctx;
};

interface TenantProviderProps {
  children: ReactNode;
  /** Optional initial tenant ID. When provided the provider uses this value
   *  instead of the cookie. Intended for embed pages. */
  initialTenantId?: number;
}

export const TenantProvider: React.FC<TenantProviderProps> = ({
  children,
  initialTenantId
}) => {
  const [tenantId] = useState<number | undefined>(() => {
    if (initialTenantId !== undefined) {
      return initialTenantId;
    }

    const sessionValue = sessionStorage.getItem("_tenantId");
    if (sessionValue) {
      const parsed = parseInt(sessionValue);
      if (!isNaN(parsed) && parsed > 0) return parsed;
    }

    const tenantCookie = Cookies.get("_cid");
    if (!tenantCookie) {
      return undefined;
    }

    return parseInt(tenantCookie);
  });

  return (
    <TenantContext.Provider value={{ tenantId: tenantId }}>
      {children}
    </TenantContext.Provider>
  );
};
